import { useState, useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import { payTransactions, payApprove } from '../../api';

const STATUS_CLS={success:'bg-green-100 text-green-600',pending:'bg-yellow-100 text-yellow-600',failed:'bg-red-100 text-red-600',manual_approved:'bg-blue-100 text-blue-600'};

export default function PaymentsTab() {
  const [txns,setTxns]   = useState([]);
  const [loading,setLoad]= useState(true);

  useEffect(()=>{ payTransactions().then(r=>setTxns(r.data.transactions||[])).catch(()=>{}).finally(()=>setLoad(false)); },[]);

  const approve = async id=>{
    try{
      await payApprove(id);
      setTxns(t=>t.map(x=>x.id===id?{...x,status:'manual_approved'}:x));
    }catch(e){ alert('Approval failed: '+e.message); }
  };

  const total   = txns.filter(t=>['success','manual_approved'].includes(t.status)).reduce((s,t)=>s+parseFloat(t.amount),0);
  const pending = txns.filter(t=>t.status==='pending').length;

  return(
    <>
      <div className="grid grid-cols-3 gap-4 mb-6">
        {[['Total Revenue','$'+total.toFixed(2),'text-green-600'],['Pending',pending,'text-yellow-600'],['All Transactions',txns.length,'text-blue-600']].map(([l,v,c],i)=>(
          <div key={i} className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 text-center"><div className={"text-2xl font-bold "+c}>{v}</div><div className="text-xs text-gray-400 mt-1">{l}</div></div>
        ))}
      </div>
      {loading?<div className="text-center py-20 text-gray-400">Loading transactions...</div>:(
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="px-5 py-3 border-b text-sm font-semibold text-gray-700">Transaction History ({txns.length})</div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-xs text-gray-400 bg-gray-50 border-b"><th className="px-4 py-3">Ref</th><th className="px-4 py-3">User</th><th className="px-4 py-3">Email</th><th className="px-4 py-3">Amount</th><th className="px-4 py-3">Method</th><th className="px-4 py-3">Date</th><th className="px-4 py-3">Status</th><th className="px-4 py-3">Action</th></tr></thead>
              <tbody>{txns.map(t=>(
                <tr key={t.id} className="border-b border-gray-50 hover:bg-gray-50">
                  <td className="px-4 py-3 font-mono text-xs text-gray-400">{t.txn_ref}</td>
                  <td className="px-4 py-3 font-medium">{t.user_name}</td>
                  <td className="px-4 py-3 text-gray-400 text-xs">{t.email}</td>
                  <td className="px-4 py-3 font-bold text-green-700">${parseFloat(t.amount).toFixed(2)}</td>
                  <td className="px-4 py-3 text-xs">{t.method}</td>
                  <td className="px-4 py-3 text-xs text-gray-400">{new Date(t.created_at).toLocaleDateString()}</td>
                  <td className="px-4 py-3"><span className={"text-xs px-2 py-0.5 rounded-full font-semibold "+(STATUS_CLS[t.status]||'')}>{t.status}</span></td>
                  <td className="px-4 py-3">
                    {t.status==='pending'&&<button onClick={()=>approve(t.id)} className="flex items-center gap-1 text-xs bg-green-600 text-white px-3 py-1.5 rounded-lg hover:bg-green-500"><CheckCircle size={11}/>Approve</button>}
                  </td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}
